type CreateTemplateStepHeaderProps = {
  step?: number;
  totalSteps?: number;
  title: string;
  description?: string;
};

export const CreateTemplateStepHeader = ({
  step,
  totalSteps,
  title,
  description,
}: CreateTemplateStepHeaderProps) => {
  return (
    <div className="space-y-2 border-b border-border pb-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">{title}</h2>
        {step && totalSteps && (
          <span className="text-sm text-gray-500">
            Step {step} of {totalSteps}
          </span>
        )}
      </div>
      {description && <p className="text-sm text-gray-600">{description}</p>}
    </div>
  );
};
